import { z } from "zod"


export const E164_PHONE_REGEX = /^\+[1-9]\d{1,14}$/
export const E164_PHONE_OR_EMPTY_REGEX = /^(?:\+[1-9]\d{1,14})?$/

export type E164PhoneOptions = {
  allowEmpty?: boolean
}

export const makeZE164Phone = (zod: typeof z, options?: E164PhoneOptions) => {
  const allowEmpty = options?.allowEmpty ?? false
  return zod.string().trim().regex(allowEmpty ? E164_PHONE_OR_EMPTY_REGEX : E164_PHONE_REGEX, {
    message: allowEmpty
      ? "Expected an empty string or a phone number in E.164 format (e.g. +33608707197)."
      : "Expected a phone number in E.164 format (e.g. +33608707197).",
  })
}

export const zE164Phone = (options?: E164PhoneOptions) => makeZE164Phone(z, options)
